import { TEnv } from "models";

export function getEnv(): TEnv {
  const currentEnv =
    typeof window !== "undefined" ? window.location.hostname.split(".")[0] : "";

  if (!currentEnv || currentEnv === "abbhome") {
    return "prod";
  }

  if (currentEnv === "localhost") {
    return "local";
  }

  if (currentEnv === "kabinet-dev" || currentEnv === "dev") {
    return "dev";
  }

  if (currentEnv === "kabinet-test" || currentEnv === "test") {
    return "test";
  }

  return "prod";
}
